<template>
  <div class="Slider__slide">
    <div class="Slider__slide_wrap">
      <a
        :href="slide.href"
        class="Slider__link"
        target="_blank"
        rel="noreferrer nofollow"
      >
        <img
          :src="require(`@/assets/images/${slide.logo}`)"
          :alt="slide.href"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Slide",
  props: {
    slide: {
      type: Object,
      required: true
    }
  }
};
</script>
